import React from "react";
import CalendarSection from "../Etkinlik/Calendar";

function useResponsive() {
  const [isMobile, setIsMobile] = React.useState(window.innerWidth <= 600);
  React.useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= 600);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);
  return isMobile;
}

const CalendarSlide = () => {
  const isMobile = useResponsive();

  return (
    <div className="home-calendar-slide" style={styles.container}>
      <div style={styles.wrapper}>
        <div
          style={
            isMobile
              ? { ...styles.page, ...styles.pageMobile }
              : styles.page
          }
        >
          <div style={isMobile ? styles.pageInnerMobile : undefined}>
            <CalendarSection />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CalendarSlide;

const styles = {
  wrapper: {
    display: "flex",
    flexDirection: "column",
    height: "calc(var(--app-vh, 1vh) * 100)",
    minHeight: "calc(var(--app-vh, 1vh) * 100)",
    maxHeight: "calc(var(--app-vh, 1vh) * 100)",
    overflow: "hidden",
  },
  page: {
    flex: "1 0 auto",
    minHeight: 0,
    height: "100%",
    overflow: "hidden",
    paddingTop: "20px",
    boxSizing: "border-box",
  },
  container: {
    position: "relative",
    width: "100vw",
    height: "calc(var(--app-vh, 1vh) * 100)",
    zIndex: 2,
  },
  // Responsive: mobile — slide yüksekliğini tam doldur (takvim tek ekrana sığsın)
  pageMobile: {
    paddingTop: 0,
    display: "flex",
    flexDirection: "column",
    justifyContent: "stretch",
    alignItems: "stretch",
    height: "100%",
    minHeight: 0,
    overflow: "hidden",
    boxSizing: "border-box",
  },
  pageInnerMobile: {
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    minHeight: 0,
    overflow: "hidden",
    borderRadius: 10,
    boxShadow: "0 2px 8px #0001",
  },
};